import { useState } from "react";

/**
 * The always-empty last row. Typing a title and pressing Enter adds a KPI in
 * place — this is the whole "create" flow, so no dialog exists to open.
 *
 * Focus stays here after Enter so a run of KPIs can be typed one after
 * another; the new row appears above with everything else editable inline.
 *
 * @param {object} props
 * @param {number} props.columnCount every column, select box included
 * @param {boolean} [props.disabled] e.g. several financial years are showing, so a new row has no year
 * @param {(title: string) => void} props.onSeed
 */
export default function KpiGhostRow({ columnCount, disabled, onSeed }) {
  const [title, setTitle] = useState("");

  const commit = () => {
    const trimmed = title.trim();
    if (!trimmed) return;
    onSeed(trimmed);
    setTitle("");
  };

  const onKeyDown = (e) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    commit();
  };

  return (
    <tr className="kgb-ghost">
      <td className="kgb-col-select" aria-hidden="true">
        +
      </td>
      <td className="kgb-col-title">
        <input
          type="text"
          className="kgb-ghost-input"
          value={title}
          disabled={disabled}
          placeholder={disabled ? "Pick one financial year to add a KPI" : "+ Add KPI — type a title, press Enter"}
          aria-label="Add a KPI"
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={onKeyDown}
        />
      </td>
      <td className="kgb-ghost-hint" colSpan={Math.max(columnCount - 2, 1)}>
        <button type="button" className="kgb-btn kgb-btn--quiet" disabled={disabled || !title.trim()} onClick={commit}>
          Add row
        </button>
      </td>
    </tr>
  );
}
